import React, { FC } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { font } from '@styles/fonts';
import { scale } from '@components/frame';
import i18n from 'i18n-js';
import Loading from '@components/loading';
import { WithColor } from '@styles/colors';

interface LoadingStateProps extends WithColor {
  message?: string;
}

const LoadingState: FC<LoadingStateProps> = ({ C, message }) => {
  return (
    <View style={[styles.container, { backgroundColor: 'transparent' }]}>
      <View style={styles.loaderWrapper}>
        <Loading background="transparent" color={C('Link/Light/Primary')} />
      </View>
      <Text style={[font.Body, { color: C('Label/Light/Primary'), marginTop: scale(16) }]}>
        {message || i18n.t('Loading comparison...')}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: scale(20),
  },
  loaderWrapper: {
    width: '100%',
    height: scale(80),
  },
});

export default LoadingState;
